import React, { useState, useEffect,useRef, useMemo} from 'react';
import { Bar, Doughnut, Line } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import {Chart, ArcElement,CategoryScale,LinearScale,PointElement,LineElement,BarElement,Legend,Tooltip} from 'chart.js'
Chart.register(ArcElement,CategoryScale,LinearScale,
PointElement,LineElement,BarElement,Legend,Tooltip);

const ResponsiveGridLayout = WidthProvider(Responsive);
const AnalyticsComponent = ({ blocks, setblocks,get_chart,editingblocks,seteditingblocks,delete_block, handleEdit,updateBlockPosition}) => {

  
  const [isResizing, setIsResizing] = useState(false);
  const [layout, setLayout] = useState([]);

  const truncateBlockName = (name) => {
    return name?.length > 30 ? name?.slice(0, 30) + '...' : name;
    };

const generateColors = (count) => {
  const colors = [];
  for (let i = 0; i < count; i++) {
    colors.push(`hsl(${i * 360 / count}, 70%, 60%)`);
  }
  return colors;
};

const generateConsistentColor = (index) => {
  const colors = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00ff00', '#ff00ff', '#00ffff'];
  return colors[index % colors.length];
};

const blockMap = useMemo(() => {
    const map = {};
    if (blocks && blocks.length > 0) {
      blocks.forEach(block => {
        map[block.id.toString()] = block;
      });
    }
    return map;
  }, [blocks]);

const getChartData = (block) => {


  if (block.chartType === 'pie') {
    var datasets = ''
    var labels = ''
    var data_x = ''
    //console.log('block.final_values_',block.final_values_)
    var datasets = Object.keys(block.final_values_).map((key, index) => ({
      label: key === 'None' ? '' : key,
      data: block.final_values_[key].value_,
      fill: false,
      pointRadius: 8,
      pointHoverRadius: 10,
      backgroundColor: generateColors(block.final_values_[key]?.legends_?.length),
      borderColor: 'black',
    }));
  
    var labels = Object.values(block.final_values_)
  .map((key_) => key_.legends_)
  .reduce((acc, legends) => (legends?.length > acc.length ? legends : acc), []);
    data_x = { labels: labels, datasets: datasets };

  

  return data_x



    } 
  else {
    var datasets = []
    var labels = ''
    var data_x = ''

   

    if (block.attribute_id.includes('Metric')) {
      
    var labels = [...new Set(Object.values(block.final_values_).flatMap(item => item.legends_))].sort();
    
    const parseDate = (label) => {
      const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;  // Format: 2025-03-02
      const weekRegex = /^(\d{4})-(\d{2})-W(\d+)$/;   // Format: 2024-03-W1
      const monthRegex = /^(\d{4})-([A-Za-z]+)$/;     // Format: 2024-Jan

        let match;
        if ((match = label.match(dateRegex))) {
            return new Date(match[1], match[2] - 1, match[3]); // YYYY-MM-DD
        } else if ((match = label.match(weekRegex))) {
            const year = parseInt(match[1]);
            const month = parseInt(match[2]) - 1;
            const week = parseInt(match[3]);
            return new Date(year, month, week * 7); // Approximate week to a day
        } else if ((match = label.match(monthRegex))) {
            const year = parseInt(match[1]);
            const month = new Date(`${match[2]} 1, ${year}`).getMonth();
            return new Date(year, month, 1); // Month-based format
        }
        return new Date(label); // Fallback (not expected)
    };

    // Sort labels chronologically
    labels.sort((a, b) => parseDate(a) - parseDate(b));

    Object.keys(block.final_values_).forEach((key) => {
      const { value_, legends_ } = block.final_values_[key];
  
      // Function to align data with sorted labels
      const getAlignedData = (category) => labels.map(label => {
          const index = legends_.indexOf(label);
          return index !== -1 ? parseInt(value_[category][index]) : null; // Use null for missing values
      });
  
      // Create datasets for Good, Neutral, and Bad with aligned data
      datasets.push({
          label: key === 'None' ? 'Good' : `${key} Good`,
          data: getAlignedData('Good'),
          fill: false,
          pointRadius: 8,
          pointHoverRadius: 10,
          backgroundColor: 'Green',
          borderColor: 'Green',
      });
  
      datasets.push({
          label: key === 'None' ? 'Neutral' : `${key} Neutral`,
          data: getAlignedData('Neutral'),
          fill: false,
          pointRadius: 8,
          pointHoverRadius: 10,
          backgroundColor: 'Yellow',
          borderColor: 'Yellow',
      });
  
      datasets.push({
          label: key === 'None' ? 'Bad' : `${key} Bad`,
          data: getAlignedData('Bad'),
          fill: false,
          pointRadius: 8,
          pointHoverRadius: 10,
          backgroundColor: 'Red',
          borderColor: 'Red',
      });
  });

      
      var data_x = {
        labels: labels,
        datasets: datasets,
      };
      
      return data_x
    }
  
    else {
   
    
  var labels = [...new Set(Object.values(block.final_values_).flatMap(item => item.legends_))].sort();
    
    const parseDate = (label) => {
      const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;  // Format: 2025-03-02
      const weekRegex = /^(\d{4})-(\d{2})-W(\d+)$/;   // Format: 2024-03-W1
      const monthRegex = /^(\d{4})-([A-Za-z]+)$/;     // Format: 2024-Jan

      let match;
      if ((match = label.match(dateRegex))) {
          return new Date(match[1], match[2] - 1, match[3]); // YYYY-MM-DD
      } else if ((match = label.match(weekRegex))) {
          const year = parseInt(match[1]);
          const month = parseInt(match[2]) - 1;
          const week = parseInt(match[3]);
          return new Date(year, month, week * 7); // Approximate week to a day
      } else if ((match = label.match(monthRegex))) {
          const year = parseInt(match[1]);
          const month = new Date(`${match[2]} 1, ${year}`).getMonth();
          return new Date(year, month, 1); // Month-based format
      }
      return new Date(label); // Fallback (not expected)
  };

  // Sort labels chronologically
  labels.sort((a, b) => parseDate(a) - parseDate(b));
    
    
  var datasets = Object.keys(block.final_values_).map((key,index) => {
      const datasetValues = labels.map(label => {
          // Find index of legend for this dataset
          const legendIndex = block.final_values_[key].legends_.indexOf(label);
          return legendIndex !== -1 ? parseInt(block.final_values_[key].value_[legendIndex]) : null; // null for missing data
      });
          return {
            label: key === "None" ? "" : key,
            data: datasetValues, // Aligned data
            fill: false,
            pointRadius: 8,
            pointHoverRadius: 10,
            backgroundColor: (Object.keys(block.final_values_).length > 1) ? generateConsistentColor(index) : block.chartColor,
            borderColor: (Object.keys(block.final_values_).length > 1) ? generateConsistentColor(index) : block.chartColor
        };
    });
    
    
    var data_x = {
      labels: labels,
      datasets: datasets,
    };
    
    return data_x
  }

  }

}

  const renderChart = (block) => {
    
    switch (block.chartType) {
      case 'pie':
        return (
          <Doughnut
            data={getChartData(block)}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: "left",
                  labels: {
                    usePointStyle: true,
                    font: {
                      size: 12
                    },
                    padding: 15
                  },
                },
                tooltip: {
                  backgroundColor: 'rgba(0,0,0,0.8)',
                  titleFont: {
                    size: 14
                  },
                  bodyFont: {
                    size: 13
                  },
                  padding: 12,
                  cornerRadius: 8,
                  displayColors: true
                }
              },
              animation: {
                duration: 1000,
                easing: 'easeOutQuart'
              },
              scales: { x: { display: false }, y: { display: false } }
            }}
          />
        );
      
      case 'line':
        return (
          <Line
            data={getChartData(block)}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: "top",
                  align: "center",
                  labels: {
                    usePointStyle: true,
                    font: {
                      size: 12
                    },
                    padding: 15
                  },
                },
                tooltip: {
                  backgroundColor: 'rgba(0,0,0,0.8)',
                  titleFont: {
                    size: 14
                  },
                  bodyFont: {
                    size: 13
                  },
                  padding: 12,
                  cornerRadius: 8,
                  displayColors: true,
                  intersect: false,
                  mode: 'index'
                }
              },
              scales: {
                x: {
                  grid: {
                    display: true,
                    color: 'rgba(200, 200, 200, 0.2)',
                    drawBorder: false
                  },
                  ticks: {
                    color: '#666',
                    font: {
                      size: 11
                    }
                  }
                },
                y: {
                  grid: {
                    display: true,
                    color: 'rgba(200, 200, 200, 0.2)',
                    drawBorder: false
                  },
                  ticks: {
                    color: '#666',
                    font: {
                      size: 11
                    }
                  },
                  beginAtZero: true
                }
              },
              elements: {
                line: {
                  tension: 0.4
                },
                point: {
                  radius: 3,
                  hitRadius: 10,
                  hoverRadius: 5,
                  hoverBorderWidth: 2
                }
              },
              animation: {
                duration: 1000,
                easing: 'easeOutQuart'
              }
            }}
          />
        );

      case 'bar':
        return (
          <Bar
            data={getChartData(block)}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: "top",
                  align: "center",
                  labels: {
                    usePointStyle: true,
                    font: {
                      size: 12
                    },
                    padding: 15
                  },
                },
                tooltip: {
                  backgroundColor: 'rgba(0,0,0,0.8)',
                  titleFont: {
                    size: 14
                  },
                  bodyFont: {
                    size: 13
                  },
                  padding: 12,
                  cornerRadius: 8,
                  displayColors: true
                }
              },
              scales: {
                x: {
                  grid: {
                    display: false
                  },
                  ticks: {
                    color: '#666',
                    font: {
                      size: 11
                    }
                  }
                },
                y: {
                  grid: {
                    display: true,
                    color: 'rgba(200, 200, 200, 0.2)',
                    drawBorder: false
                  },
                  ticks: {
                    color: '#666',
                    font: {
                      size: 11
                    }
                  },
                  beginAtZero: true
                }
              },
              animation: {
                duration: 1000,
                easing: 'easeOutQuart'
              }
            }}
          />
        );
      
      case 'number':return (
        ((Object.keys(block.final_values_).length==1) && (Object.keys(block.final_values_)[0]=='None'))? (

               <div style={{
                   color: block.chartColor,
                   fontSize: `${Math.min(block.width / (block?.final_values_['None']['value_'][0].length * 0.6), block.height / 2)}px`,
                   overflow: "hidden",
                   overflowX: "scroll",
                   whiteSpace: "nowrap",
                   textOverflow: "ellipsis",
                   //display:"flex",
                   textAlign:"center",
                   margin:"0px",
                   width:'100%',
                   height:'100%',
                   padding:"0px"
                    }}>
                {block?.final_values_['None']['value_'][0]}
                </div>
              
                )
              :
              (
              <div style={{
                display: "flex",
                justifyContent: "center",
                
                width:'100%', 
                height:'100%',
                textAlign:"center",
              }}>
                <table style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f5f5f5",textAlign:"center", }}>
                    <th style={{
                        padding: "12px",
                        fontSize: "16px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        textAlign:"center",
                        background:"#42006C",
                        color:"white"
                      }}>
                      </th>
                      <th style={{
                        padding: "12px",
                        fontSize: "16px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        textAlign:"center",
                        background:"#42006C",
                        color:"white"
                      }}>
                        {block.groupby_id}
                      </th>
                      <th style={{
                        padding: "12px",
                        fontSize: "16px",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                        textAlign:"center",
                        background:"#42006C",
                        color:"white"
                      }}>
                        {block.attribute_id}
                      </th>
  
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(block.final_values_).map((key, index) => (
                      <tr key={index} style={{
                        textAlign: "center",
                        backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                        transition: "background-color 0.3s ease",
                      }}>
                        <td style={{
                          padding: "12px",
                          fontSize: "16px",
                          borderBottom: "1px solid #ddd",
                          background:"#42006C",
                          color:"white"
                        }}>
                          {index+1}
                        </td>

                        <td style={{
                          padding: "12px",
                          fontSize: "16px",
                          borderBottom: "1px solid #ddd",
                        }}>
                          {key}
                        </td>

                        <td style={{
                          padding: "12px",
                          fontSize: "20px",
                          color: block.chartColor,
                          borderBottom: "1px solid #ddd",
                        }}>
                          {block.final_values_[key].value_}
                        </td>

                        
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>                 
        )
      )
        default:
        return null;
    }
  };

  const renderChartCard = (block) => {
    //console.log('renderChartCard block',block)
    return (
      <div
        className="chart-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        style={{
          display: "flex",
          flexDirection: "column",
          width: '100%',
          height: '100%',
          background: "white",
          borderRadius: "15px",
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          padding: "15px",
          transition: "all 0.3s ease",
          position: "relative",
          overflow: "hidden",
          boxSizing: "border-box"
        }}
        
      >
      <div
          style={{
            position: "absolute",
            top: "0px",
            left: "0px",
            right: "0px",
            height: "4px",
            background: "linear-gradient(90deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 50%, rgb(240, 147, 251) 100%)",
            borderRadius: "20px 20px 0px 0px"
          }}
        ></div>

        <div className="chart-header" style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          paddingBottom: "10px",
          borderBottom: "1px solid rgba(200, 200, 200, 0.5)",
          width: "100%"
        }}>
          <h3 
            style={{ 
              fontSize: "16px",
              fontWeight: "600",
              textAlign: "left",
              margin: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "80%"
            }}
            data-tooltip-id="chart-tooltip"
            data-tooltip-content={block.blockName}
          >
            {truncateBlockName(block.blockName)}
          </h3>
          
          <div className="chart-actions" style={{ position: "relative" }}>
            <button
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "5px"
              }}
              onClick={() => toggleDropdown(block.id)}
            >
              <FontAwesomeIcon
                icon={faEllipsisV}
                style={{ 
                  width: "16px", 
                  height: "16px", 
                  color: "#555" 
                }}
              />
            </button>
            
            
              {openDropdownIndex === block.id && (
                <div
                style={{
                  position: "absolute",
                  top: "100%",
                  right: "0",
                  backgroundColor: "white",
                  borderRadius: "6px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                  zIndex: 1000,
                  minWidth: "120px",
                  overflow: "hidden",
                  border: "1px solid rgba(0,0,0,0.1)"
                }}
              >
                <button
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#333"
                  }}
                  onClick={() => handleEdit(block.id)}
                  onMouseEnter={(e) => e.target.style.backgroundColor = "#f5f5f5"}
                  onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
                >
                  Edit Chart
                </button>
                <button
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#dc3545"
                  }}
                  onClick={() => delete_block(block.id)}
                  onMouseEnter={(e) => e.target.style.backgroundColor = "#f5f5f5"}
                  onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
                >
                  Delete Chart
                </button>
              </div>
              )}
            
          </div>
        </div>
        
        <div className="chart-content" style={{ flex: 1, width: "100%", height: "calc(100% - 45px)" }}>
          {renderChart(block)}
        </div>
      </div>
    );
  };

  const [openDropdownIndex, setOpenDropdownIndex] = useState(-1);

  const toggleDropdown = (id) => {
    setOpenDropdownIndex(openDropdownIndex === id ? -1 : id);
  };

  
  useEffect(() => {
      if (blocks && blocks.length > 0) {
        const newLayout = blocks.map((block, index) => ({
          i: block.id.toString(),
          x: block.x ? Math.floor(block.x / 300) : (index % 3),
          y: block.y ? Math.floor(block.y / 350) : Math.floor(index / 3), 
          w: block.width ? Math.ceil(block.width / 300) : 1,
          h: block.height ? Math.ceil(block.height / 300) : 1,
          minW: 1,
          minH: 1,
          maxW: 3,
          maxH: 2,
        }));
        setLayout(newLayout);
      }
    }, [blocks]);

  const handleLayoutChange = (newLayout) => {
    //console.log('xxx',newLayout)
    // Skip during active resize to reduce API calls
    //if (isResizing) return;
    
    setLayout(newLayout);

    // Find the block that changed
    newLayout.forEach(item => {
      const block = blocks.find(b => b.id.toString() === item.i);
      if (block) {
        const x = item.x * 300;
        const y = item.y * 350;
        const width = item.w * 300;
        const height = item.h * 300;

        // Only send update if position or size actually changed
        if (block.x !== x || block.y !== y || block.width !== width || block.height !== height) {
          updateBlockPosition(block.id, x, y, width, height);
        }
      }
    });
  };



return (
     <>
     <div style={{ width: '100%', padding: '20px' }}>
      {blocks.length> 0 && (
      <ResponsiveGridLayout
        className="layout"
        layouts={{ lg: layout }}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 3, md: 2, sm: 2, xs: 1, xxs: 1 }}
        rowHeight={300}
        margin={[20, 20]}
        isDraggable={editingblocks}
        isResizable={editingblocks}
        onResizeStart={() => setIsResizing(true)}
        onResizeStop={() => {
          setTimeout(() => setIsResizing(false), 500);
        }}
        onLayoutChange={handleLayoutChange}
        useCSSTransforms={true}
        compactType="horizontal"
        preventCollision={false}        
      >
       {layout.map(item => {
          const block = blockMap[item.i];
          if (!block) return null;
          
          return (
            <div key={item.i} style={{ overflow: "hidden" }}>
              {renderChartCard(block)}
            </div>
          );
        })}
      </ResponsiveGridLayout>
      )}
      
    </div>

    </>
    )
};

export default AnalyticsComponent;